// extracted by mini-css-extract-plugin
export var menuIcon = "_sp-0";
export var menuIconInline = "_sp-1";